export default class TeamFeedHandler {
    constructor() {
        this.departmentTabs = null;
        this.teamMembers = null;
        this.selectedDepartment = null;
    }

    init() {
        const teamFeed = document.querySelector('[data-id="team-feed"]');
        if (!teamFeed) return;

        this.departmentTabs = teamFeed.querySelectorAll('[data-department-tab]');
        this.teamMembers = teamFeed.querySelectorAll('[data-team-member]');

        this.initDepartmentFilters();
        this.initFromURL();
    }

    initDepartmentFilters() {
        if (!this.departmentTabs || this.departmentTabs.length === 0) return;

        this.departmentTabs.forEach(tab => {
            tab.addEventListener('click', (e) => {
                e.preventDefault();
                const department = tab.dataset.departmentTab;
                this.filterByDepartment(department, true);
            });
        });
    }

    filterByDepartment(department, updateURL = false) {
        // Update active tab using data attribute
        this.departmentTabs.forEach(tab => {
            if (tab.dataset.departmentTab === department) {
                tab.dataset.active = 'true';
                tab.setAttribute('aria-selected', 'true');
            } else {
                tab.dataset.active = 'false';
                tab.setAttribute('aria-selected', 'false');
            }
        });

        // Show/hide team members using data attribute
        this.teamMembers.forEach(member => {
            const memberDepartments = member.dataset.departments || '';

            if (memberDepartments.includes(department)) {
                member.dataset.visible = 'true';
            } else {
                member.dataset.visible = 'false';
            }
        });

        if (updateURL) {
            this.updateURL(department);
        }

        this.selectedDepartment = department;
    }

    initFromURL() {
        const urlParams = new URLSearchParams(window.location.search);
        const department = urlParams.get('department');

        if (department) {
            // Check if department exists in our tabs
            const departmentTab = document.querySelector(`[data-department-tab="${department}"]`);
            if (departmentTab) {
                this.filterByDepartment(department);
                return;
            }
        }

        // If no valid department in URL, select first department
        if (this.departmentTabs && this.departmentTabs.length > 0) {
            const firstDepartment = this.departmentTabs[0].dataset.departmentTab;
            this.filterByDepartment(firstDepartment);
        }
    }

    updateURL(department) {
        const url = new URL(window.location);
        url.searchParams.set('department', department);
        window.history.pushState({ department }, '', url);
    }

    destroy() {
        // Clean up if needed
        this.departmentTabs = null;
        this.teamMembers = null;
    }
}